<template>
  <div class="mt-8 space-y-4">
    <div class="body-1-bold flex justify-between">
      <div>{{ totalTitle }}</div>
      <div class="ml-24" data-qa="price-after-discount">
        {{ i18n.price(priceAfterDiscount) }}
      </div>
    </div>
  </div>
  <div
    v-if="withSwap && totalPriceAfterBuyback"
    class="body-2 mt-8 flex justify-between"
  >
    <RevButtonBase
      class="text-action-default-hi underline"
      @click="openSummaryModal"
    >
      {{ i18n(translations.totalPriceAfterBuyback) }}
    </RevButtonBase>
    <span class="ml-24">{{ i18n.price(totalPriceAfterBuyback) }}</span>
  </div>
</template>

<script setup lang="ts">
import type { MonetaryAmount } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './TotalAmount.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

withDefaults(
  defineProps<{
    totalTitle: string
    priceAfterDiscount: MonetaryAmount
    totalPriceAfterBuyback?: MonetaryAmount
    withSwap: boolean
  }>(),
  {
    totalPriceAfterBuyback: undefined,
  },
)

const openSummaryModal = () => {
  trackClick({
    zone: 'cart_summary',
    name: 'swap_cart_modal',
  })

  openModal(MODAL_NAMES.SWAP_SUMMARY)
}
</script>
